/* eslint-disable no-undef */
function findUser(callback) {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('id_token')
  };
  return fetch(`/api/v1/users/findUser`, {
    headers
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function createUser(profile, callback) {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('id_token')
  };
  return fetch(`/api/v1/users/createUser`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(profile),
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function getVideos(callback) {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('id_token')
  };
  return fetch(`/api/v1/users/getVideos`, {
    headers
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.log(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const Users = {
  findUser,
  createUser,
  getVideos,
};
export default Users;



// WEBPACK FOOTER //
// ./src/api/Users.js